// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603051003/js/" + chunkId + "." + {"44":"e304f40a","225":"1a5dd9df","481":"be714c03","486":"f11487e0","770":"836e9773"}[chunkId] + ".0.5070935789908129.chunk.js";
};